import * as React from 'react'
import { useCallback, useEffect, useReducer, useState } from 'react'
import GridItem from '../../grid/GridItem'
import Card from '../../card/Card'
import CardHeader from '../../card/CardHeader'
import CardBody from '../../card/CardBody'
import GridContainer from '../../grid/GridContainer'
import { makeStyles } from '@material-ui/core/styles'
import { useParams } from 'react-router-dom'
import Container from '@material-ui/core/Container'
import Backdrop from '@material-ui/core/Backdrop'
import CircularProgress from '@material-ui/core/CircularProgress'
import { timeout } from '../../../App'
import CustomInput from '../../input/CustomInput'
import Button from '../../button/RegularButton'
import DepartmentSignatures from '../DepartmentSignatures'
import { AddAlert } from '@material-ui/icons'
import Snackbar from '../../snackbar/Snackbar'
import { initialNotificationState } from '../../utils/state/ApplicationState'
import { getApiUrl } from '../../../api/api'

const styles = {
  cardCategoryWhite: {
    color: 'rgba(255,255,255,.62)',
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    marginBottom: '0',
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: '\'Roboto\', \'Helvetica\', \'Arial\', sans-serif',
    marginBottom: '3px',
    textDecoration: 'none',
  },
}

const useStyles = makeStyles(styles)

function departureReducer(state, action) {
  switch (action.type) {
    case 'field':
      return {
        ...state,
        [action.field]: action.value,
      }

    case 'fetch':
      return {
        ...state,
        ...action.value,
      }

    case 'success':
      return {
        ...state,
        success: true,
      }

    case 'error':
      return {
        ...state,
        success: false,
        errorMessage: action.errorMessage,
      }

    default:
      break
  }
  return state
}

const initialDepartureState = {
  status: null,
  tenantName: null,
  departureDate: null,
  createdOn: null,
  departureId: null,
  signatures: [],
  iban: null,
  name: null,
}

export default function PublicDepartureDecision() {
  const classes = useStyles()

  const [proceeding, setProceeding] = useState(true)
  const [state, dispatch] = useReducer(departureReducer, initialDepartureState)
  const [notification, setNotification] = useState(initialNotificationState)

  const [bankInfo, setBankInfo] = useState({
    iban: null,
    name: null,
  })

  const { departureId } = useParams()

  const fetchBankInfo = useCallback(() => {
    getApiUrl()
      .get(`/public/departures/${departureId}/bank`)
      .then(function(response) {
        setProceeding(false)
        setBankInfo(response.data)
      })
      .catch(function(error) {
        console.log(error)
        setProceeding(false)
      })
      .finally(
        setTimeout(function() {
          setNotification(initialNotificationState)
        }, timeout),
      )
  }, [departureId])

  const fetchDeparture = useCallback(() => {
    getApiUrl()
      .get(`/public/departures/${departureId}`)
      .then(function(response) {
        setProceeding(false)
        dispatch({ type: 'fetch', value: response.data })
      })
      .catch(function(error) {
        console.log(error)
        setProceeding(false)
      })
  }, [departureId])

  const saveBankInfo = (e) => {
    e.preventDefault()
    setProceeding(true)

    getApiUrl()
      .post(`/public/departures/${departureId}/bank`, { name: state.name, iban: state.iban })
      .then(function() {
        setProceeding(false)
        fetchBankInfo()
      })
      .catch(function(error) {
        console.log(error)
        setProceeding(false)
        setNotification({
          open: true,
          message: 'Bitte Name und IBAN eingeben.',
          color: 'danger',
        })
      })
      .finally(
        setTimeout(function() {
          setNotification(initialNotificationState)
        }, timeout),
      )
  }

  const confirmDeparture = (e) => {
    e.preventDefault()
    setProceeding(true)

    getApiUrl()
      .patch(`/public/departures/${state.departureId}/confirm`, state)
      .then(function() {
        setProceeding(false)
        setNotification({
          open: true,
          message: 'Aktion wurde erfolgreich durchgeführt.',
          color: 'success',
        })
      })
      .catch(function(error) {
        console.log(error)
        setProceeding(false)
        setNotification({
          open: true,
          message: 'Bitte Name und IBAN eingeben.',
          color: 'danger',
        })
      })
      .finally(
        setTimeout(function() {
          setNotification(initialNotificationState)
        }, timeout),
      )
  }

  const postponeDeparture = (e) => {
    e.preventDefault()
    setProceeding(true)

    getApiUrl()
      .patch(`/public/departures/${state.departureId}/postpone`, {})
      .then(function() {
        setProceeding(false)
        setNotification({
          open: true,
          message: 'Aktion wurde erfolgreich durchgeführt.',
          color: 'success',
        })
      })
      .catch(function(error) {
        console.log(error)
        setProceeding(false)
        setNotification({
          open: true,
          message: error.response.data.message,
          color: 'danger',
        })
      })
      .finally(
        setTimeout(function() {
          setNotification(initialNotificationState)
        }, timeout),
      )
  }

  useEffect(() => {
    fetchBankInfo()
    fetchDeparture()
  }, [fetchBankInfo, fetchDeparture])

  if (proceeding) {
    return (
      <Backdrop open={proceeding}>
        <CircularProgress color="inherit"/>
      </Backdrop>
    )
  }

  if (state.status === 'CREATED') {
    return (
      <Container component="main" maxWidth="md">
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="primary">
                <h4 className={classes.cardTitleWhite}>Im Schollheim wohnen bleiben</h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <h5>
                      Um Deine Wohnzeit zu verlängern, musst du eine Bewerbung bei der Verwaltung einreichen. Drücke den
                      Button, um den Verlängerungsprozess zu starten.
                    </h5>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={2}>
                        <br/>
                        <Button
                          color="primary"
                          onClick={(e) => {
                            postponeDeparture(e)
                          }}>
                          Verlängerung starten
                        </Button>
                      </GridItem>
                    </GridContainer>
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="primary">
                <h4 className={classes.cardTitleWhite}>Das Schollheim verlassen</h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <h5>
                      Falls Du zum {state.departureDate} ausziehen möchtest, hinterlege bitte ein Bankkonto, auf welches
                      die Kaution zurücküberwiesen werden soll.
                    </h5>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={5}>
                    <CustomInput
                      labelText="Kontoinhaber/in"
                      id="name"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: state.name,
                        type: 'text',
                        onChange: (e) =>
                          dispatch({
                            type: 'field',
                            field: 'name',
                            value: e.currentTarget.value,
                          }),
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={7}>
                    <CustomInput
                      labelText="IBAN"
                      id="iban"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: state.iban,
                        type: 'text',
                        onChange: (e) =>
                          dispatch({
                            type: 'field',
                            field: 'iban',
                            value: e.currentTarget.value,
                          }),
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={2}>
                        <br/>
                        <Button
                          color="primary"
                          onClick={(e) => {
                            confirmDeparture(e)
                          }}>
                          Auszug bestätigen
                        </Button>
                      </GridItem>
                    </GridContainer>
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        <Snackbar
          place="br"
          color={notification.color}
          icon={AddAlert}
          message={notification.message}
          open={notification.open}
          closeNotification={() =>
            setNotification({
              open: false,
              message: '',
              color: '',
            })
          }
          close
        />
      </Container>
    )
  }

  if (state.status === 'CONFIRMED' || state.status === 'CLOSED') {
    return (
      <Container component="main" maxWidth="md">
        <GridContainer>
          {bankInfo.name == null ? (
            <GridItem xs={12} sm={12} md={12}>
              <Card>
                <CardHeader color="primary">
                  <h4 className={classes.cardTitleWhite}>Kontodaten</h4>
                </CardHeader>
                <CardBody>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <h5>Hinterlege bitte ein Bankkonto, auf welches die Kaution zurücküberwiesen werden soll.</h5>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={5}>
                      <CustomInput
                        labelText="Kontoinhaber/in"
                        id="name"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          value: state.name,
                          type: 'text',
                          onChange: (e) =>
                            dispatch({
                              type: 'field',
                              field: 'name',
                              value: e.currentTarget.value,
                            }),
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={7}>
                      <CustomInput
                        labelText="IBAN"
                        id="iban"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          value: state.iban,
                          type: 'text',
                          onChange: (e) =>
                            dispatch({
                              type: 'field',
                              field: 'iban',
                              value: e.currentTarget.value,
                            }),
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <GridContainer>
                        <GridItem xs={12} sm={12} md={2}>
                          <br/>
                          <Button
                            color="primary"
                            onClick={(e) => {
                              saveBankInfo(e)
                            }}>
                            Kontodaten bestätigen
                          </Button>
                        </GridItem>
                      </GridContainer>
                    </GridItem>
                  </GridContainer>
                </CardBody>
              </Card>
            </GridItem>
          ) : (
            <GridItem xs={12} sm={12} md={12}>
              <Card>
                <CardHeader color="primary">
                  <h4 className={classes.cardTitleWhite}>Kontodaten</h4>
                </CardHeader>
                <CardBody>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <h5>Die Kaution wird auf dieses Konto zurücküberwiesen.</h5>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={5}>
                      <CustomInput
                        labelText="Kontoinhaber/in"
                        id="name"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          disabled: true,
                          value: bankInfo.name,
                          type: 'text',
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={7}>
                      <CustomInput
                        labelText="IBAN"
                        id="iban"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          disabled: true,
                          value: bankInfo.iban,
                          type: 'text',
                        }}
                      />
                    </GridItem>
                  </GridContainer>
                </CardBody>
              </Card>
            </GridItem>
          )}
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="primary">
                <h4 className={classes.cardTitleWhite}>Eingegangene Unterschriften für {state.tenantName}</h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <DepartmentSignatures signatures={state.signatures}/>
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        <Snackbar
          place="br"
          color={notification.color}
          icon={AddAlert}
          message={notification.message}
          open={notification.open}
          closeNotification={() =>
            setNotification({
              open: false,
              message: '',
              color: '',
            })
          }
          close
        />
      </Container>
    )
  }

  if (state.status === 'POSTPONED') {
    return (
      <Container component="main" maxWidth="md">
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="primary">
                <h4 className={classes.cardTitleWhite}>Wohnzeitverlängerung</h4>
              </CardHeader>
              <CardBody>
                <h4>
                  Die Verwaltung wurde über deine Anfrage informiert. Die auszufüllenden Unterlagen für Deine Bewerbung
                  um Wohnzeitverlängerung liegen dort nun zur Abholung bereit.
                </h4>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </Container>
    )
  }

  return (
    <Container component="main" maxWidth="md">
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="primary">
              <h4 className={classes.cardTitleWhite}>Fehler</h4>
            </CardHeader>
            <CardBody>
              <h4>Ein Fehler ist aufgetreten. Bitte den Admin kontaktieren polovyi@schollheim.net</h4>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </Container>
  )
}
